export const reduceMicrocopySet = (mcSet) => {
  if (mcSet === undefined || mcSet === null) {
    return undefined
  }

  return reduceMicrocopy(mcSet.items)
}

export const reduceMicrocopy = (microcopy) => {
  if (microcopy === undefined || microcopy === null) {
    return undefined
  }

  return microcopy.reduce((obj, label) => {
    return { [label.title]: label.text, ...obj }
  }, {})
}
